import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const TopHeadingContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 15px;
`;

export const TopButtonsContainer = styled.div`
  display: flex;
`;

export const Header = styled.h1`
  color: ${colors.darkBlue};
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 42px;
  min-width: 220px;
`;

export const OuterContainer = styled.div`
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e5e5e5;
  background: white;
`;

export const AnchorLink = styled.a`
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  text-decoration: none;
  color: ${colors.white};

  :hover {
    color: ${colors.green};
    text-decoration: none;
  }
`;

export const CompanyPhotoContainer = styled.div`
  display: flex;
  padding: 15px 0 0 15px;
`;

export const CompanyPhoto = styled.label`
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  width: 120px;
  height: 120px;
  background-image: url(${(props) => props.image || ''});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  position: relative;
  overflow: hidden;
`;

export const CompanyPhotoInput = styled.input.attrs({
  type: 'file',
  accept: 'image/png, image/jpeg, image/jpg, image/svg+xml',
})`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
`;

export const UploadPhotoLabel = styled.label`
  position: absolute;
  top: 45px;
  left: 25px;
  line-height: 1;
  border-radius: 5px;
  padding: 5px;
  background: rgba(0, 0, 0, 0.3);
  height: 30px;
  color: white;
  font-size: 14px;
  cursor: pointer;
`;

export const ContainerHeading = styled.h5`
  color: ${colors.darkBlue};
`;

export const FieldsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  width: 100%;
  padding: 10px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DescriptionQuillContainer = styled.div`
  background-color: white;
  margin-top: 15px;
  padding: 10px;
`;

export const ExtraCompanySettingsContainer = styled.div`
  padding: 10px;
`;
export const LabelAndCheckboxContainer = styled.div`
  margin-top: 8px;
  display: flex;
  cursor: pointer;
`;

export const Label = styled.label`
  margin-left: 8px;
  margin-bottom: 0px;
  color: #373a3c;
  font-size: 15px;

  ${(props) =>
    props.isInputNumberLabel &&
    css`
      display: flex;
      align-items: end;
    `}
`;

export const HideTestLabel = styled.label`
  margin: ${(props) => props.margin || '18px 0 0 0'};
  color: #373a3c;
  font-size: 15px;
`;

export const FlexContainer = styled.div`
  display: flex;
`;

export const HideTestCategoriesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  width: 100%;
  margin-top: 5px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ErrorMessage = styled.p`
  color: ${colors.red};
  font-weight: 600;
  padding-left: 10px;
  padding: ${(props) => props.padding} !important;
`;

export const DepartmentListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding-top: 8px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 736px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const DepartmentHeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SwitchableInput = styled.input.attrs((props) => ({
  readOnly: !props.isEditing,
}))`
  background: transparent;
  border: none;
  outline: none;
  color: ${colors.darkGray};
  padding: 0;
  border-radius: 0;

  ${(props) =>
    props.isEditing &&
    css`
      border-bottom: 1px solid ${colors.lightGray2};
    `};
`;

export const TextInput = styled(SwitchableInput)`
  font-size: 16px;
  display: flex;
  align-items: center;
  line-height: 20px;
  padding: 5px;
  margin: ${(props) => props.margin || '15px 0 0 0'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height};

  ${(props) =>
    props.isTeamMemberInput &&
    css`
      margin: 0px;
      text-align: center;
      color: ${colors.darkBlue};
      font-size: 15px;
      font-weight: 600;
    `};

  ${(props) =>
    props.fullWidthOnMobile &&
    css`
      @media (max-width: 768px) {
        width: 100%;
      }
    `};
`;

export const EmailTabContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.grids}, 1fr);
  grid-gap: ${(props) => props.gridGap || '2'}px;
  width: 100%;
  margin-top: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const EmailTab = styled.div`
  text-align: center;
  font-size: 14px;
  background: ${colors.darkBlue};
  border: 2px solid ${colors.darkBlue};
  color: white;
  cursor: pointer;
  padding: 14px 5px;
  border-radius: 5px;

  ${(props) =>
    !props.active &&
    css`
      &:hover {
        background: #185080;
      }
    `};

  ${(props) =>
    props.active &&
    css`
      border: 2px solid ${colors.green};
      background: ${colors.white};
      color: ${colors.green};
    `};
`;

export const EmailContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubjectInput = styled.input.attrs({
  type: 'text',
})`
  padding: 0.7em;
  border: 1px solid ${colors.gray};
  margin-bottom: 15px;
  font-size: 13px;

  &:focus-visible {
    outline: ${colors.gray};
  }
`;

export const SubjectLabel = styled.label`
  font-size: 14px;
`;

export const TeamMembersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
`;

export const TeamMemberContainer = styled.div`
  width: 182px;
  height: ${(props) => (props.isDepartmentSettingsPage ? '206px' : '250px')};
  background-color: #cccccc;
  border-radius: 5px;
  margin: 10px 20px;
  white-space: nowrap;
  text-align: center;
  position: relative;
`;

export const AvatarContainer = styled.div`
  margin: auto;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-position: center top;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${(props) => props.image || ''});
`;

export const EmailAndDepartmentLabel = styled.div`
  font-size: 13px;
  color: ${colors.darkBlue};
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 0 5px 0 5px;
`;

export const FAIcon = styled.i.attrs(({ icon }) => ({
  // icon is a required prop
  className: icon,
}))`
  margin-right: 2px;
  margin-top: 7px;
  color: ${colors.darkBlue};
  cursor: pointer;
`;

export const CrossButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  border-width: 0px;
  color: #fff;
  background-color: ${colors.red};
  border-color: ${colors.red};
`;

export const PersonalDetailsContainer = styled.div`
  margin-top: ${(props) => (props.margin ? '31px' : '0px')};
`;

export const PrivacyText = styled.div`
  font-size: 15px;
  line-height: 1.8;
`;

export const PrivacyPreviewHeading = styled.h5`
  color: ${colors.darkBlue};
`;

export const PrivacyPreviewContainer = styled.div`
  border-radius: 0.25rem;
  border: 1px solid #e5e5e5;
  background: #fff;
  margin-top: 8px;
  padding: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  font-size: 14px;
  line-height: 1.8;
  overflow: auto;
  height: 165px;
`;

export const PrivacyContainer = styled.div`
  padding: 15px 15px 0 15px;
`;

export const IntegrationContainer = styled.div`
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  margin: 15px 15px 0 15px;
  padding: 15px;
`;

export const IntegrationFieldLabel = styled.label`
  color: #666666;
  font-size: 14px;
  margin: ${(props) => props.margin};
`;

export const RecruitmentStagesContainer = styled.div`
  padding: 0px 15px 0 15px;
`;

export const ProficiencyContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 20px;
  width: 100%;
  padding: 10px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ProficiencySubContainer = styled.div``;

export const SeparationLine = styled.hr``;

export const VATAndIconContainer = styled.div`
  display: flex;
  align-items: baseline;
`;

export const VATIcon = styled.i.attrs(({ icon }) => ({
  // icon is a required prop
  className: icon,
}))`
  color: ${(props) => props.color};
`;
